import {useSelector} from "react-redux";

export default function  useSelectedExam() {
    const user = useSelector((state)=>state.user);
    return user.selectedExam;
}